<template>

  <div id="dlnkdocs_form">

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>

    <div class="modal fade text-body" id="document_modal" tabindex="-1" role="dialog"
         aria-labelledby="new_document_modalLabel">
      <form id="document_form"
            enctype="multipart/form-data"
            method="post"
            @submit.prevent="post_document">

        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="new_document_modalLabel">Ajouter un document</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                  aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="required form-group">
                <label for="title" class="required">
                  Titre
                </label>
                <input id="title" name="document[title]" type="text"
                       class="is_required form-control"
                       :class="{'is-invalid': errors.title, 'is-valid': valid.title}"
                       @blur="validate_title"
                       v-model="document.title">
                <div class="invalid-feedback">
                  Le titre doit contenir entre 3 et 128 caractères.
                </div>
              </div>

              <div class="required form-group">
                <label for="description" class="">
                  Description
                </label>

                <textarea id="description"
                          name="document[description]" rows="5"
                          class="form-control"
                          :class="{'is-invalid': errors.description, 'is-valid': valid.description}"
                          @blur="validate_description"
                          v-model="document.description"></textarea>

                <div class="invalid-feedback">
                  La description doit contenir au minimum 3 caractères.
                </div>
              </div>

              <div class="required form-group">
                <label for="section" class="required w-100">
                  Section
                  <i class="fas fa-plus nav-icon float-right text-primary" @click.prevent.stop="toggle_section_form()"></i>

                  <div v-if="form_section_visible" class="text-popover">
                    <div class="form-inline shadow p-3 border rounded bg-light" accept-charset="UTF-8" method="post">
                      <label class="sr-only" for="new_section">Section</label>
                      <input class="form-control mb-2 mr-sm-2 w-100" placeholder="Section ..." type="text" id="new_section" v-model="new_section">

                      <div class="invalid-feedback">
                        Le nom de la section doit contenir entre 1 et 255 caractères.
                      </div>
                      <button type="button" class="btn btn-secondary mr-2" @click="toggle_section_form()">Annuler</button>
                      <button type="button" class="btn btn-success"   @click.prevent.stop="submit_section_form()">Valider</button>
                    </div>
                  </div>
                </label>
                <select id="section" name="document[section_id]"
                        class="form-control"
                        :class="{'is-invalid': errors.section, 'is-valid': valid.section}"
                        @blur="validate_section"
                        v-model="document.section_id">
                  <option v-for="section in sections"
                          :key="section.id"
                          :value="section.id">{{section.section}}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Vous devez choisir une section
                </div>
              </div>

              <div v-if="typeof group_id == 'undefined' || group_id == 0">
                <div v-if="master_company">
                  <input name="document[community_access]" type="hidden" value="0" autocomplete="off">
                  <input id="is_community" type="checkbox" value="1" name="document[community_access]" />
                  <label for="is_community">Accès pour toutes les communautés</label>
                </div>

                <div class="form-group" >
                  <input name="document[public]" type="hidden" value="0" autocomplete="off">
                  <input id="public" type="checkbox" value="1" name="document[public]" v-model="document.public" />
                  <label for="public">Document public</label>
                </div>

                <div class="form-group">
                  <input name="document[visible_homepage]" type="hidden" value="0" autocomplete="off">
                  <input id="visible_homepage" type="checkbox" v-model="document.visible_homepage" value="1" name="document[visible_homepage]" />
                  <label for="visible_homepage">Visible sur la homepage</label>
                </div>
              </div>

              <div class="required form-group">
                <label for="kind" class="required w-100">
                  Menu
                  <i class="fas fa-plus nav-icon float-right text-primary" @click.prevent.stop="toggle_menu_form()"></i>

                  <div v-if="form_menu_visible" class="text-popover">
                    <div class="form-inline shadow p-3 border rounded bg-light" accept-charset="UTF-8" method="post">
                      <label class="sr-only" for="new_section">Menu</label>
                      <input class="form-control mb-2 mr-sm-2 w-100" placeholder="Section ..."
                             type="text" id="new_section" v-model="new_menu">

                      <div class="invalid-feedback">
                        Le nom du menu doit contenir entre 3 et 100 caractères.
                      </div>
                      <button type="button" class="btn btn-secondary mr-2" @click="toggle_menu_form()">Annuler</button>
                      <button type="button" class="btn btn-success"   @click.prevent.stop="submit_menu_form()">Valider</button>
                    </div>
                  </div>

                </label>
                <select id="type" name="document[type_id]" class="form-control" v-model="document.type_id">
                  <option value='0'>Défaut</option>
                  <option v-for="menu in menus" :value='menu.id'>{{menu.name}}</option>
                </select>
              </div>


              <div class="form-group">
                <label for="kind">Type</label>
                <select id="type" name="document[kind]" class="form-control" v-model="document.kind">
                  <option value='file'>Document</option>
                  <option value='video'>Vidéo</option>
                  <option value='internet'>Document internet</option>
                </select>
              </div>

              <div v-if="document.kind == 'file'">
                <div class="form-group">

                  <input id="file" type="file" name="file"/>
                  <label for="file"> Taille maximum 30 Mo </label>

                  <div class="invalid-feedback">
                    Veuillez télécharger un document
                  </div>
                </div>
              </div>

              <div class="form-group" v-else-if="document.kind == 'video' ">
                <label for="video_url">URL (vidéo YouTube)</label>
                <input class="form-control" id="video_url" name="document[video_url]" type="text">
              </div>

              <div class="form-group" v-else-if="document.kind == 'internet' ">
                <label for="internet_url">URL (document internet)</label>
                <input class="form-control" id="intenet_url" name="document[internet_url]"
                       type="text" v-model="document.internet_url">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
              </button>
              <button
                  type="submit"
                  class="btn btn-primary"
                  name="new_document" >
                <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
    export default {
      props: ['sections', 'group_id', 'document', 'menus'],

      data: function () {
        return {
          message: '',
          messsage_type: '',

          master_company: false,

          title: '',
          description: '',
          section_id: '',
          new_section: String,
          new_menu: String,
          form_section_visible: Boolean,
          form_menu_visible: Boolean,

          errors: {
            title: false,
            description: false,
            file: false,
            section: false,
          },

          valid: {
            title: false,
            description: false,
            file: false,
            section: false,
          }

        }
      },

      mounted() {
        this.new_section = ""
        this.new_menu = ""
        this.form_section_visible = false
        this.form_menu_visible = false
      },

      methods: {

        toggle_section_form: function () {
          this.form_section_visible = !this.form_section_visible;
        },

        toggle_menu_form: function () {
          this.form_menu_visible = !this.form_menu_visible;
        },

        close_message: function () {
          this.message = null;
        },

        post_document: function () {
          const _this = this;

          if (_this.validate_fields()) {
            let method = 'post'

            get_token_2().then(function (response) {
              let [secure_key, customer_id, api_url, customer] = response

              if(Number.isInteger(_this.document.id)) {
                method = 'patch'
                api_url += `documents/${_this.document.id}.json`
              } else {
                api_url += "documents.json"
              }

              api_url += '?secure_key=' + secure_key
              api_url += '&customer_id=' + customer_id

              const form_element = document.getElementById("document_form");
              const form_data = new FormData(form_element);

              if (_this.group_id != undefined && _this.group_id > 0) {
                form_data.append('document[group_id]', _this.group_id)
              }

              axios({
                method: method,
                url: api_url,
                data: form_data
              })
                  .then(function (response) {
                    _this.message = 'Document enregistré'
                    _this.message_type = "alert-success"
                    _this.$emit('get_data')
                    $('#document_modal').modal('hide')
                  })
                  .catch(function (error) {
                    const field = Object.keys(error.response.data)[0]
                    const error_message = error.response.data[field][0]
                    _this.message = error_message;
                    _this.message_type = "alert-danger";
                  })
                  .then(function () {
                        // always executed
                      }
                  );
            })
          }
        },

        validate_fields: function () {
          return !this.validate_description() && !this.validate_section() && !this.validate_title()
        },

        validate_section: function () {
          this.errors.section = false;
          if(this.document.section_id < 0) {
            this.errors.section = true;
          }
          return this.errors.section
        },

        validate_description: function () {
          this.errors.description = false;
          if(this.document.description.length < 3) {
            this.errors.description = true;
          } else {
            this.valid.description = true;
          }
          return this.errors.description
        },

        validate_title: function () {
          this.errors.title = false
          if(this.document.title.length < 3 || this.document.title.length > 128) {
            this.errors.title = true
          } else {
            this.valid.title = true
          }
          return this.errors.title
        },

        submit_section_form: function () {
          let _this = this
          get_token_2().then(function (response) {
            let [secure_key, customer_id, api_url, customer] = response
            api_url += "document_sections.json"
            api_url += '?secure_key=' + secure_key
            api_url += '&customer_id=' + customer_id

            const form_data = new FormData();
            form_data.append('section[section]', _this.new_section)

            axios({
              method: 'post',
              url: api_url,
              data: form_data
            })
                .then(function (response) {
                  _this.$emit('get_data')
                  _this.toggle_section_form()
                  _this.message = "Section ajoutée.";
                  _this.message_type = 'alert-success'
                })
                .catch(function (error) {
                  const field = Object.keys(error.response.data)[0]
                  const error_message = error.response.data[field][0]
                  _this.message = error_message;
                  _this.message_type = "alert-danger";
                  _this.toggle_section_form()
                })
                .then(function () {
                      // always executed
                    }
                );
          })
        },

        submit_menu_form: function () {
          let _this = this
          get_token_2().then(function (response) {
            let [secure_key, customer_id, api_url, customer] = response
            api_url += "document_types.json"
            api_url += '?secure_key=' + secure_key
            api_url += '&customer_id=' + customer_id

            const form_data = new FormData();
            form_data.append('type[name]', _this.new_menu)

            axios({
              method: 'post',
              url: api_url,
              data: form_data
            })
                .then(function (response) {
                  _this.$emit('get_data')
                  _this.toggle_menu_form()
                  _this.message = "Menu ajouté.";
                  _this.message_type = 'alert-success'
                })
                .catch(function (error) {
                  const field = Object.keys(error.response.data)[0]
                  const error_message = error.response.data[field][0]
                  _this.message = error_message;
                  _this.message_type = "alert-danger";
                  _this.toggle_menu_form()
                })
                .then(function () {
                      // always executed
                    }
                );
          })
        },

      }
    }
</script>

